import { useNavigate } from 'react-router-dom'

import { useSession } from '../../../contexts/SessionContext'
import {
  useDirectDebitStatus,
  DirectDebitStatus,
} from '../../../contexts/session/DirectDebitContext'
import SessionCountdownTimer from '../../elements/v2/SessionCountdownTimer'
import { ReactComponent as CloseDuotoneSvg } from '../../../assets/svg/close-duotone.svg'

const Header = () => {
  const { sessionData, sessionExpiresAt } = useSession()
  const { directDebitStatus } = useDirectDebitStatus()
  const navigate = useNavigate()

  // Hide the countdown once the client timer is no longer the source of truth:
  // the transfer-confirmation stage is governed by the backend poll, and the
  // terminal stages (success/failed/expired) have no live session left to count.
  const HIDE_COUNTDOWN_STATUSES = [
    DirectDebitStatus.TRANSFER_CONFIRMATION,
    DirectDebitStatus.SUCCESS,
    DirectDebitStatus.FAILED,
    DirectDebitStatus.EXPIRED,
  ]
  const showCountdown = !HIDE_COUNTDOWN_STATUSES.includes(directDebitStatus?.status)

  const postCancelMessage = () => {
    const response = window.confirm(
      'Are you sure you want to cancel this payment?'
    )

    if (response) {
      closeIframe()
    }
  }

  const closeIframe = () => {
    //Check if checkout is in an iframe
    if (window.self !== window.top) {
      // Send message to parent page to indicate checkout cancellation
      window.parent.postMessage('close-iframe', '*')
    } else {
      sessionData.charge_url && window.location.replace(sessionData.charge_url)
      !sessionData.charge_url && navigate(-1)
    }
  }

  return (
    <div className='d-flex justify-content-between align-items-center'>
      <div>
        <div style={{ color: '#344054' }} className='fw-medium'>
          {sessionData?.merchantName || 'Checkout'}
        </div>
        {showCountdown && <SessionCountdownTimer expiresAt={sessionExpiresAt} />}
      </div>

      <button
        id='close-button'
        className='border-0 bg-transparent p-0'
        onClick={postCancelMessage}
      >
        <CloseDuotoneSvg width={24} />
      </button>
    </div>
  )
}

export default Header
